<template>
  <div class="product-card-skeleton-wrapper flex flex-col">
    <n-skeleton class="rounded w-full h-full aspect-1.7 mb-3 flex-1" />
    <n-skeleton class="rounded w-full h-4 mt-1 mb-1 md:mb-2" text />
    <n-skeleton class="rounded w-full h-4 mt-1" text />
    <div class="flex gap-1 my-3">
      <n-skeleton v-for="i in 4" :key="i" class="rounded-full size-14" text />
    </div>
  </div>
</template>

<script setup lang="ts">
import { NSkeleton } from 'naive-ui'
</script>
